import React, { useState } from "react";
import "./SelectActionImpl.css";
import ErrorAlert from "../../layout/ErrorAlert";
import { Button, Descriptions, Input, Layout, Tabs, Typography } from "antd";
import InputParameters from "../../actions/ActionInputParameters";
import "./ActionSummary.css";
import SelectActionImplContainer from "./SelectActionImpl.container";
import { ResourceReference } from "../ResourceRef";
import {
  ActionSummaryInput,
  AdvancedModeInput,
} from "./ActionSummary.container";
import { EditOutlined, SettingOutlined } from "@ant-design/icons";
import TypeInstancesListContainer, {
  GenericTypeInstanceData,
} from "../../typeinstances/TypeInstancesList.container";

const { Content } = Layout;
const { Text, Paragraph } = Typography;
const { TabPane } = Tabs;

interface ActionSummaryProps {
  data: ActionSummaryInput;
  error?: Error;

  isSubmitLoading: boolean;
  submitFunc: () => void;

  setActionName: (name: string) => void;
  advancedModeInput: AdvancedModeInput;
  setAdvancedModeInput: (advModeInput: AdvancedModeInput) => void;
}

function ActionSummary({
  error,
  data,
  isSubmitLoading,
  advancedModeInput,
  submitFunc,
  setActionName,
  setAdvancedModeInput,
}: ActionSummaryProps) {
  const [editableInputName, setEditableInputName] = useState(false);

  if (error) {
    return <ErrorAlert error={error} />;
  }

  const actionNameField = () => {
    if (editableInputName) {
      return (
        <Input
          defaultValue={data.input.name}
          bordered={false}
          onBlur={(f) => {
            setActionName(f.target.value);
            setEditableInputName(false);
          }}
          ref={(ref) => {
            ref?.focus({
              cursor: "all",
            });
          }}
        />
      );
    }
    return (
      <>
        {data.input.name}
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={() => setEditableInputName(true)}
        />
      </>
    );
  };

  const inputParamsSource = (parameters?: string) => {
    if (!parameters) {
      return undefined;
    }
    const objParams = JSON.parse(data.input.input?.parameters ?? {});
    return Object.keys(objParams).map((key) => {
      return {
        name: key,
        value: objParams[key],
      };
    });
  };

  const inputTypeInstances = data.input.input?.typeInstances ?? [];
  const inputTypeInstanceData: GenericTypeInstanceData[] =
    inputTypeInstances.map((ti) => {
      return {
        id: ti.id,
        name: ti.name,
      };
    });

  // maybe extra as switch to advance mode?
  return (
    <Content className="action-summary">
      <Descriptions column={1} bordered>
        <Descriptions.Item label="Name">{actionNameField()}</Descriptions.Item>
        <Descriptions.Item label="ClusterTemplate">
          <Text code>Kubectl</Text>
        </Descriptions.Item>
      </Descriptions>
      <Tabs defaultActiveKey="1" style={{ marginTop: "24px" }}>
        <TabPane tab="Inputs" key="1">
          <Descriptions
            column={1}
            layout="vertical"
            bordered
            style={{ marginTop: "24px" }}
          >
            <Descriptions.Item label="Input Parameters">
              <InputParameters
                dataSource={inputParamsSource(data.input.input?.parameters)}
              />
            </Descriptions.Item>
          </Descriptions>
        </TabPane>
        <TabPane
          tab={
            <>
              <SettingOutlined style={{ marginRight: "6px" }} />
              {"Advanced Settings"}
            </>
          }
          key="2"
        >
          <SelectActionImplContainer
            actRef={
              new ResourceReference(
                data?.input.actionRef.path,
                data?.input.actionRef.revision
              )
            }
            advancedModeInput={advancedModeInput}
            setAdvancedModeInput={setAdvancedModeInput}
          />
        </TabPane>
      </Tabs>
      <Button
        className="summary-submit-btn"
        type="primary"
        onClick={submitFunc}
        loading={isSubmitLoading}
      >
        Submit
      </Button>
    </Content>
  );
}

export default ActionSummary;
